const styles = (theme) => ({
  root: {
    width:"250px",
    height:"165px"
  },
  anchorPointRoot:{
    width:"260px",
    // height:"138px"
  },
  table:{
    height:"100%",
    width:"100%",
  },
  tableHead: {
    backgroundColor: theme.headColor,
  },
  tableBody: {
    "& tr:last-child td": {
      paddingBottom: 8,
    },
  },
  tableHeadHeight:{
    height:"52px",
    '& $tableHeaderCell':{
      paddingTop: "6px",
    }
  },
  tableHeaderCell: {
    color: theme.headFontColor,
    borderBottom: 0,
    fontSize:"12px",
  },
  tableHeadCell: {
    color: theme.headFontColor,
    borderBottom: 0,
    fontSize:"12px",
  },
  tableRowRoot: {
    height: "25px",
  },
  anchorPointTableRowRoot: {
    height: 24,
    '& $anchorPointBtnCell':{
      borderBottom:"0px",
      paddingTop:8,
      paddingLeft:"14px"
    },
    '& $labelCell, & $dataCell':{
      paddingTop: 4
    },
    '& $dataCell':{
      display:"block",
      width: "100%",
      paddingRight: 12,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace:"nowrap",
      boxSizing:"border-box",
      paddingLeft: 8,
      fontSize: '10px',
      fontWeight: 400
  }
  },
  routeInfo:{
    float:"right",
    fontSize:"10px",
    paddingRight:"12px"
  },
  customerName:{
    float:"left",
    paddingLeft:"12px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    lineHeight:"17px",
    width:"165px",
    textOverflow:"ellipsis"
  },
  address:{
    clear:"both",
    fontSize:"10px",
    lineHeight:"20px",
    color:theme.address,
    paddingLeft:"12px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    height:"20px",
    width:"130px",
    textOverflow:"ellipsis",
    display: 'inline-block'
  },
  firstTableCell:{
    paddingTop:"10px",
  },
  lastTableCell:{
    paddingBottom:"15px",
  },
  popupDataStyle:{},
  labelCell: {
    borderBottom: 0,
    fontSize: 10,
    paddingLeft: "12px",
    lineHeight: "14px",
  },
  dataCell: {
    borderBottom: 0,
    fontSize: 12,
    //fontWeight:600,
    lineHeight:"17px",
    '&$firstTableCell':{
      paddingTop:"10px"
    },
    '&$lastTableCell':{
      paddingBottom:"15px",
    },
    '&$popupDataStyle':{
      paddingLeft:"12px"
    }
  },
  nameCellPadding:{
    paddingRight:"25px"
  },
  routePopupButton: {
    paddingRight:"5px",
  },
  popupButton: {
    fontSize: 9,
    padding:"0px",
    borderColor: theme.headColor,
    color: theme.headColor,
    fontWeight:"600",
    borderRadius: "2px",
    height:"25px",
    width:"101px",
    textTransform: "none",
    '&:hover':{
      backgroundColor: theme.btnHoverColor
    }
  },
  anchorPointBtn:{
    fontSize: 9,
    borderRadius: "2px",
    borderColor: theme.anchorPointBtnBorder,
    color: theme.dropAnchorPointBtn,
    height:"25px",
    width:"95%",
    fontWeight:"600",
    textTransform: "none",
  },
  tableButtonCell:{
    borderBottom:"0px",
    padding:"0px 4px 12px 10px",
    '&$tableButtonRight':{
      padding:"0px 10px 12px 4px",
    }
  },
  tableButtonRight:{},
  anchorPointBtnCell:{},
  routeNameInfo:{
    float:"left",
    paddingLeft:"6px",
    display:"flex",
    maxWidth: "60%"
  },
  anchorPointHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: 6,
  },
  anchorPointHeaderData: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    flexGrow: 1,
  },
  anchorPointDetail:{
    display: "flex",
    justifyContent: "space-between",
  },
  emptyTime:{
    fontSize: theme.dispatchCardTextFontSize,
    lineHeight:"14px",
  },
  headerIcon: {
    paddingRight: '6px',
    alignItems: 'center',
    display: 'flex'
  },
  startTime:{
    fontSize:"10px",
    lineHeight:"14px",
    float:"right",
    paddingRight:"12px",
    height: "70%"
  },
  headHeight:{
    height:"34px"
  },
  disabled:{
    cursor:"not-allowed",
    '& $disabledBtn':{
      borderColor: theme.anchorPointBtnBorder,
      color: theme.dropAnchorPointBtn,
    }
  },
  disabledBtn:{
  },
  progress:{
    color: theme.dropAnchorPointBtn,
  },
  rightCell:{
    width:100
  },
  nearbyRoutesStyle:{
    fontSize:"9px",
    lineHeight:"13px",
    color:theme.headColor,
    paddingLeft:"12px",
  },
  nearbyRoutesLabel:{
    textDecoration:"underline",
    '&:hover':{
      opacity:"0.8"
    }
  },
  zonePopUp:{
    width: "180px",
  },
  SpecialInstruction:{
    width: "100px",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  dualCellLeft:{
      display: "inline-block", 
      paddingRight: "10px",
    },
  dualCellRight:{
      display: "inline-block", 
      paddingLeft: "10px",
      borderLeft: "1px solid #D8D8D8",
  },
  popupIconContainer:{
    float: "right",
    paddingRight: "10px", 
    paddingTop: "3px",
    display: "flex",
    paddingBottom: "4px",
    alignItems: "center"
  },
  popupIcon:{
    display: "inline-block",
    paddingLeft: "3px",
    fontSize: "11px",
    fontWeight: "100",
  },
  routeStop:{
    width: "230px",
  },
  iconClass:{
    paddingRight:4,
    fontSize:16,
    color: theme.headFontColor,
    display:'flex',
    alignSelf:'center'
  },
  dividerStyle: {
    borderRight: `1px solid ${theme.borderColor}`,
    margin: "1 6 0 6",
    opacity: 0.5,
    borderWidth: "0.1px"
  },
  boldFont: {
    fontWeight: 500,
    textTransform: 'uppercase',
  },
  italicFont: {
    fontStyle: 'italic',
    paddingTop: 4,
    textTransform: "none"
  },
  routeName: {
    whiteSpace: "normal"
  },
  mergeNameWrap: {
    display: "inline-flex",
    alignItems: "center",
  },
  });
export default styles;